(function () {
  'use strict';

  var DATA = Array.isArray(window.NO_FITMENT_DATA) ? window.NO_FITMENT_DATA : [];
  var STORAGE_VEHICLES = 'nitrousOutletGarageVehiclesV1';
  var STORAGE_ACTIVE = 'nitrousOutletGarageActiveV1';

  function $(selector, root) {
    return (root || document).querySelector(selector);
  }

  function $$(selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function normalize(value) {
    return String(value || '').trim().toLowerCase();
  }

  function unique(values) {
    return Array.from(new Set(values.filter(function (value) {
      return value !== undefined &&
        value !== null &&
        String(value).trim() !== '';
    }))).sort(function (a, b) {
      return String(a).localeCompare(
        String(b),
        undefined,
        {
          numeric: true
        }
      );
    });
  }

  function safeParse(value, fallback) {
    try {
      return JSON.parse(value);
    } catch (error) {
      return fallback;
    }
  }

  /* =========================================================
     STORAGE
     ========================================================= */

  function storageGet(key) {
    try {
      return localStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function storageSet(key, value) {
    try {
      localStorage.setItem(key, value);
    } catch (error) {
      console.warn(
        'Nitrous Outlet Garage storage unavailable.',
        error
      );
    }
  }

  function storageRemove(key) {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      console.warn(
        'Nitrous Outlet Garage storage unavailable.',
        error
      );
    }
  }

  function getSavedVehicles() {
    var vehicles =
      safeParse(
        storageGet(STORAGE_VEHICLES),
        []
      );

    return Array.isArray(vehicles)
      ? vehicles
      : [];
  }

  function setSavedVehicles(vehicles) {
    storageSet(
      STORAGE_VEHICLES,
      JSON.stringify(vehicles)
    );
  }

  function getActiveVehicle() {
    return safeParse(
      storageGet(STORAGE_ACTIVE),
      null
    );
  }

  function setActiveVehicle(vehicle) {
    if (vehicle) {
      storageSet(
        STORAGE_ACTIVE,
        JSON.stringify(vehicle)
      );
    } else {
      storageRemove(
        STORAGE_ACTIVE
      );
    }
  }

  /* =========================================================
     VEHICLE HELPERS
     ========================================================= */

  function vehicleID(vehicle) {
    if (!vehicle) {
      return '';
    }

    return [
      vehicle.year || '',
      vehicle.make || '',
      vehicle.model || '',
      vehicle.engine || '',
      vehicle.submodel || ''
    ]
      .join('|')
      .toLowerCase();
  }

  function vehicleName(vehicle) {
    if (!vehicle) {
      return '';
    }

    return [
      vehicle.year,
      vehicle.make,
      vehicle.model,
      vehicle.engine,
      vehicle.submodel
    ]
      .filter(Boolean)
      .join(' ');
  }

  /* =========================================================
     PRODUCT FITMENT
     ========================================================= */

  function rowsForProduct(productID) {
    productID =
      String(
        productID || ''
      );

    return DATA.filter(
      function (row) {
        if (
          !Array.isArray(
            row.productIds
          )
        ) {
          return false;
        }

        return row.productIds
          .map(function (id) {
            return String(id);
          })
          .indexOf(productID) !== -1;
      }
    );
  }

  /* =========================================================
     UNIVERSAL PRODUCTS
     ========================================================= */

  function universalFitIDs() {
    return Array.isArray(
      window.NO_UNIVERSAL_FIT_IDS
    )
      ? window.NO_UNIVERSAL_FIT_IDS.map(
          function (id) {
            return String(id);
          }
        )
      : [];
  }

  function isUniversalProduct(productID) {
    return universalFitIDs()
      .indexOf(
        String(productID || '')
      ) !== -1;
  }

  function universalApplicationNote(productID) {
    var applications =
      (
        window.NO_UNIVERSAL_APPLICATIONS &&
        typeof window.NO_UNIVERSAL_APPLICATIONS === 'object'
      )
        ? window.NO_UNIVERSAL_APPLICATIONS
        : {};

    return applications[
      String(productID || '')
    ] || '';
  }

  /* =========================================================
     VEHICLE MATCHING
     ========================================================= */

  function rowBasicVehicleMatch(
    row,
    vehicle
  ) {
    if (!vehicle) {
      return false;
    }

    var selectedYear =
      parseInt(
        vehicle.year,
        10
      );

    if (
      isNaN(selectedYear) ||
      selectedYear <
        Number(row.yearStart) ||
      selectedYear >
        Number(row.yearEnd)
    ) {
      return false;
    }

    if (
      normalize(row.make) !==
      normalize(vehicle.make)
    ) {
      return false;
    }

    if (
      normalize(row.model) !==
      normalize(vehicle.model)
    ) {
      return false;
    }

    return true;
  }

  function rowMatchesVehicle(
    row,
    vehicle
  ) {
    if (
      !rowBasicVehicleMatch(
        row,
        vehicle
      )
    ) {
      return false;
    }

    /*
      Blank engine means
      product is not restricted
      by engine.
    */

    if (row.engine) {
      if (!vehicle.engine) {
        return false;
      }

      if (
        normalize(row.engine) !==
        normalize(vehicle.engine)
      ) {
        return false;
      }
    }

    /*
      Blank submodel means
      product is not restricted
      by trim.
    */

    if (row.submodel) {
      if (!vehicle.submodel) {
        return false;
      }

      if (
        normalize(row.submodel) !==
        normalize(vehicle.submodel)
      ) {
        return false;
      }
    }

    return true;
  }

  function productNeedsMoreDetails(
    rows,
    vehicle
  ) {
    return rows.some(
      function (row) {
        if (
          !rowBasicVehicleMatch(
            row,
            vehicle
          )
        ) {
          return false;
        }

        if (
          row.engine &&
          !vehicle.engine
        ) {
          return true;
        }

        if (
          row.submodel &&
          !vehicle.submodel
        ) {
          return true;
        }

        return false;
      }
    );
  }

  /* =========================================================
     AVAILABLE VEHICLE ROWS
     ========================================================= */

  function availableRows(filters) {
    return DATA.filter(
      function (row) {

        if (filters.year) {
          var year =
            parseInt(
              filters.year,
              10
            );

          if (
            year <
              Number(row.yearStart) ||
            year >
              Number(row.yearEnd)
          ) {
            return false;
          }
        }

        if (
          filters.make &&
          normalize(row.make) !==
          normalize(filters.make)
        ) {
          return false;
        }

        if (
          filters.model &&
          normalize(row.model) !==
          normalize(filters.model)
        ) {
          return false;
        }

        if (
          filters.engine &&
          row.engine &&
          normalize(row.engine) !==
          normalize(filters.engine)
        ) {
          return false;
        }

        if (
          filters.submodel &&
          row.submodel &&
          normalize(row.submodel) !==
          normalize(filters.submodel)
        ) {
          return false;
        }

        return true;
      }
    );
  }

  /* =========================================================
     SELECT OPTIONS
     ========================================================= */

  function setOptions(
    select,
    values,
    placeholder,
    selectedValue
  ) {
    if (!select) {
      return;
    }

    select.innerHTML =
      '';

    var first =
      document.createElement(
        'option'
      );

    first.value =
      '';

    first.textContent =
      placeholder;

    select.appendChild(
      first
    );

    values.forEach(
      function (value) {
        var option =
          document.createElement(
            'option'
          );

        option.value =
          value;

        option.textContent =
          value;

        select.appendChild(
          option
        );
      }
    );

    if (
      selectedValue &&
      values.indexOf(
        selectedValue
      ) !== -1
    ) {
      select.value =
        selectedValue;
    }
  }

  /* =========================================================
     PAGE SCROLL FIX
     ========================================================= */

  function unlockPageScroll() {

    if (document.body) {

      document.body.classList.remove(
        'no-garage-open'
      );

      document.body.style.removeProperty(
        'overflow'
      );

      document.body.style.removeProperty(
        'overflow-y'
      );

      document.body.style.removeProperty(
        'position'
      );

      document.body.style.removeProperty(
        'top'
      );

      document.body.style.removeProperty(
        'width'
      );
    }

    if (document.documentElement) {

      document.documentElement.classList.remove(
        'no-garage-open'
      );

      document.documentElement.style.removeProperty(
        'overflow'
      );

      document.documentElement.style.removeProperty(
        'overflow-y'
      );
    }
  }

  /* =========================================================
     OPEN GARAGE
     ========================================================= */

  function openGarage() {

    var drawer =
      $('#noGarageDrawer');

    var backdrop =
      $('#noGarageBackdrop');

    var toggle =
      $('#noGarageToggle');

    if (drawer) {

      drawer.classList.add(
        'is-open'
      );

      drawer.style.right =
        '0';

      drawer.setAttribute(
        'aria-hidden',
        'false'
      );
    }

    if (backdrop) {

      backdrop.classList.add(
        'is-open'
      );

      backdrop.style.display =
        'block';
    }

    if (toggle) {

      toggle.setAttribute(
        'aria-expanded',
        'true'
      );
    }

    if (document.body) {

      document.body.classList.add(
        'no-garage-open'
      );
    }
  }

  /* =========================================================
     CLOSE GARAGE
     ========================================================= */

  function closeGarage() {

    var drawer =
      $('#noGarageDrawer');

    var backdrop =
      $('#noGarageBackdrop');

    var toggle =
      $('#noGarageToggle');

    if (drawer) {

      drawer.classList.remove(
        'is-open'
      );

      drawer.style.right =
        '-460px';

      drawer.setAttribute(
        'aria-hidden',
        'true'
      );
    }

    if (backdrop) {

      backdrop.classList.remove(
        'is-open'
      );

      backdrop.style.display =
        'none';
    }

    if (toggle) {

      toggle.setAttribute(
        'aria-expanded',
        'false'
      );
    }

    unlockPageScroll();
  }

  /* =========================================================
     PUBLIC FUNCTIONS
     ========================================================= */

  window.NO_GARAGE_OPEN =
    openGarage;

  window.NO_GARAGE_CLOSE =
    closeGarage;

  window.NO_GARAGE_GET_ACTIVE =
    getActiveVehicle;

  window.NO_GARAGE_ROWS_FOR_PRODUCT =
    rowsForProduct;

  /* =========================================================
     INITIALIZE GARAGE
     ========================================================= */

  function initGarage() {

    var year =
      $('#noGarageYear');

    var make =
      $('#noGarageMake');

    var model =
      $('#noGarageModel');

    var engine =
      $('#noGarageEngine');

    var submodel =
      $('#noGarageSubmodel');

    var engineField =
      $('[data-engine-field]');

    var submodelField =
      $('[data-submodel-field]');

    var saveButton =
      $('#noGarageSave');

    var garageList =
      $('#noGarageList');

    if (
      !year ||
      !make ||
      !model ||
      !saveButton ||
      !garageList
    ) {

      console.warn(
        'Nitrous Outlet Garage: required fields missing.'
      );

      return;
    }

    /* =====================================================
       YEARS
       ===================================================== */

    var years =
      [];

    DATA.forEach(
      function (row) {

        var start =
          Number(
            row.yearStart
          );

        var end =
          Number(
            row.yearEnd
          );

        if (
          isNaN(start) ||
          isNaN(end)
        ) {
          return;
        }

        for (
          var current = start;
          current <= end;
          current++
        ) {

          years.push(
            String(current)
          );
        }
      }
    );

    years =
      unique(years);

    years.sort(
      function (a, b) {
        return Number(b) -
          Number(a);
      }
    );

    setOptions(
      year,
      years,
      'Select year'
    );

    setOptions(
      make,
      [],
      'Select year first'
    );

    setOptions(
      model,
      [],
      'Select make first'
    );

    if (engine) {

      setOptions(
        engine,
        [],
        'Optional — select engine'
      );
    }

    if (submodel) {

      setOptions(
        submodel,
        [],
        'Optional — select trim'
      );
    }

    if (engineField) {
      engineField.hidden =
        true;
    }

    if (submodelField) {
      submodelField.hidden =
        true;
    }

    /* =====================================================
       SAVE BUTTON
       ===================================================== */

    function updateSaveButton() {

      var ready =
        Boolean(
          year.value &&
          make.value &&
          model.value
        );

      saveButton.disabled =
        false;

      saveButton.removeAttribute(
        'disabled'
      );

      saveButton.style.opacity =
        '1';

      saveButton.style.cursor =
        'pointer';

      saveButton.setAttribute(
        'data-ready',
        ready
          ? 'true'
          : 'false'
      );

      saveButton.setAttribute(
        'aria-disabled',
        ready
          ? 'false'
          : 'true'
      );
    }

    /* =====================================================
       RESET ENGINE / TRIM
       ===================================================== */

    function resetEngineAndTrim() {

      if (engine) {

        setOptions(
          engine,
          [],
          'Optional — select engine'
        );
      }

      if (submodel) {

        setOptions(
          submodel,
          [],
          'Optional — select trim'
        );
      }

      if (engineField) {

        engineField.hidden =
          true;
      }

      if (submodelField) {

        submodelField.hidden =
          true;
      }
    }

    /* =====================================================
       MAKES
       ===================================================== */

    function refreshMakes() {

      var rows =
        availableRows({
          year:
            year.value
        });

      var makes =
        unique(
          rows.map(
            function (row) {
              return row.make;
            }
          )
        );

      setOptions(
        make,
        makes,
        year.value
          ? 'Select make'
          : 'Select year first'
      );

      setOptions(
        model,
        [],
        'Select make first'
      );

      resetEngineAndTrim();

      updateSaveButton();
    }

    /* =====================================================
       MODELS
       ===================================================== */

    function refreshModels() {

      var rows =
        availableRows({
          year:
            year.value,

          make:
            make.value
        });

      var models =
        unique(
          rows.map(
            function (row) {
              return row.model;
            }
          )
        );

      setOptions(
        model,
        models,
        make.value
          ? 'Select model'
          : 'Select make first'
      );

      resetEngineAndTrim();

      updateSaveButton();
    }

    /* =====================================================
       ENGINES
       ===================================================== */

    function refreshEngines() {

      var rows =
        availableRows({
          year:
            year.value,

          make:
            make.value,

          model:
            model.value
        });

      var engines =
        unique(
          rows.map(
            function (row) {
              return row.engine ||
                '';
            }
          )
        );

      if (
        engine &&
        engineField
      ) {

        if (
          engines.length
        ) {

          engineField.hidden =
            false;

          setOptions(
            engine,
            engines,
            'Optional — select engine'
          );

        } else {

          engineField.hidden =
            true;

          setOptions(
            engine,
            [],
            'Optional — select engine'
          );
        }
      }

      refreshSubmodels();

      updateSaveButton();
    }

    /* =====================================================
       TRIMS / SUBMODELS
       ===================================================== */

    function refreshSubmodels() {

      if (
        !submodel ||
        !submodelField
      ) {
        return;
      }

      var rows =
        availableRows({
          year:
            year.value,

          make:
            make.value,

          model:
            model.value,

          engine:
            engine
              ? engine.value
              : ''
        });

      var submodels =
        unique(
          rows.map(
            function (row) {
              return row.submodel ||
                '';
            }
          )
        );

      if (
        submodels.length
      ) {

        submodelField.hidden =
          false;

        setOptions(
          submodel,
          submodels,
          'Optional — select trim'
        );

      } else {

        submodelField.hidden =
          true;

        setOptions(
          submodel,
          [],
          'Optional — select trim'
        );
      }

      updateSaveButton();
    }

    /* =====================================================
       SAVED VEHICLE LIST
       ===================================================== */

    function renderGarageList() {

      var vehicles =
        getSavedVehicles();

      var active =
        getActiveVehicle();

      garageList.innerHTML =
        '';

      if (
        !vehicles.length
      ) {

        var empty =
          document.createElement(
            'div'
          );

        empty.className =
          'no-garage-empty';

        empty.textContent =
          'No vehicles saved yet.';

        garageList.appendChild(
          empty
        );
      }

      vehicles.forEach(
        function (vehicle) {

          var isActive =
            active &&
            vehicleID(active) ===
            vehicleID(vehicle);

          var card =
            document.createElement(
              'div'
            );

          card.className =
            'no-garage-card' +
            (
              isActive
                ? ' is-active'
                : ''
            );

          var title =
            document.createElement(
              'div'
            );

          title.className =
            'no-garage-card__title';

          title.textContent =
            [
              vehicle.year,
              vehicle.make,
              vehicle.model
            ]
              .filter(Boolean)
              .join(' ');

          card.appendChild(
            title
          );

          var meta =
            document.createElement(
              'div'
            );

          meta.className =
            'no-garage-card__meta';

          meta.textContent =
            [
              vehicle.engine,
              vehicle.submodel
            ]
              .filter(Boolean)
              .join(' • ') ||
            'Saved vehicle';

          card.appendChild(
            meta
          );

          var actions =
            document.createElement(
              'div'
            );

          actions.className =
            'no-garage-card__actions';

          var useButton =
            document.createElement(
              'button'
            );

          useButton.type =
            'button';

          if (isActive) {

            useButton.textContent =
              'Active vehicle';

            useButton.disabled =
              true;

          } else {

            useButton.textContent =
              'Use this vehicle';

            useButton.addEventListener(
              'click',
              function () {

                setActiveVehicle(
                  vehicle
                );

                /*
                  IMPORTANT:
                  Close first so scroll
                  always gets unlocked.
                */

                closeGarage();

                updateEverything();
              }
            );
          }

          actions.appendChild(
            useButton
          );

          var removeButton =
            document.createElement(
              'button'
            );

          removeButton.type =
            'button';

          removeButton.textContent =
            'Remove';

          removeButton.addEventListener(
            'click',
            function () {

              var current =
                getSavedVehicles();

              var remaining =
                current.filter(
                  function (item) {
                    return (
                      vehicleID(item) !==
                      vehicleID(vehicle)
                    );
                  }
                );

              setSavedVehicles(
                remaining
              );

              var currentActive =
                getActiveVehicle();

              if (
                currentActive &&
                vehicleID(currentActive) ===
                vehicleID(vehicle)
              ) {

                setActiveVehicle(
                  remaining.length
                    ? remaining[0]
                    : null
                );
              }

              updateEverything();
            }
          );

          actions.appendChild(
            removeButton
          );

          card.appendChild(
            actions
          );

          garageList.appendChild(
            card
          );
        }
      );

      updateGarageButton();
    }

    window.NO_GARAGE_RENDER_LIST =
      renderGarageList;

    /* =====================================================
       FIELD EVENTS
       ===================================================== */

    year.addEventListener(
      'change',
      refreshMakes
    );

    make.addEventListener(
      'change',
      refreshModels
    );

    model.addEventListener(
      'change',
      refreshEngines
    );

    if (engine) {

      engine.addEventListener(
        'change',
        refreshSubmodels
      );
    }

    if (submodel) {

      submodel.addEventListener(
        'change',
        updateSaveButton
      );
    }

    /* =====================================================
       SAVE VEHICLE
       ===================================================== */

    saveButton.addEventListener(
      'click',
      function () {

        if (
          !year.value ||
          !make.value ||
          !model.value
        ) {

          alert(
            'Select a year, make and model first.'
          );

          return;
        }

        var vehicle = {

          year:
            year.value,

          make:
            make.value,

          model:
            model.value,

          engine:
            (
              engine &&
              engineField &&
              !engineField.hidden
            )
              ? engine.value
              : '',

          submodel:
            (
              submodel &&
              submodelField &&
              !submodelField.hidden
            )
              ? submodel.value
              : ''
        };

        var vehicles =
          getSavedVehicles();

        var exists =
          vehicles.some(
            function (item) {
              return (
                vehicleID(item) ===
                vehicleID(vehicle)
              );
            }
          );

        if (!exists) {

          vehicles.push(
            vehicle
          );

          setSavedVehicles(
            vehicles
          );
        }

        setActiveVehicle(
          vehicle
        );

        /*
          IMPORTANT:
          Close BEFORE refreshing.
          This fixes stuck scrolling.
        */

        closeGarage();

        updateEverything();
      }
    );

    renderGarageList();

    updateSaveButton();
  }

  /* =========================================================
     MY GARAGE BUTTON LABEL
     ========================================================= */

  function updateGarageButton() {

    var active =
      getActiveVehicle();

    $$(
      '[data-garage-toggle-vehicle]'
    )
      .forEach(
        function (label) {

          label.textContent =
            active
              ? vehicleName(active)
              : 'Add vehicle';
        }
      );
  }

  /* =========================================================
     PRODUCT FITMENT BOX
     ========================================================= */

  function renderFitmentBoxes() {

    var active =
      getActiveVehicle();

    $$(
      '.no-fitment-box[data-product-id]'
    )
      .forEach(
        function (box) {

          var productID =
            box.getAttribute(
              'data-product-id'
            );

          var universalFit =
            isUniversalProduct(
              productID
            );

          var universalNote =
            universalApplicationNote(
              productID
            );

          var rows =
            rowsForProduct(
              productID
            );

          /* ===============================================
             UNIVERSAL / NO YMM DATA

             IMPORTANT:
             ONLY HIDE THE PRODUCT FITMENT BOX.

             DO NOT HIDE MY GARAGE.
             =============================================== */

          if (
            universalFit ||
            universalNote ||
            !rows.length
          ) {

            box.hidden =
              true;

            return;
          }

          /*
            Product has actual YMM
            fitment rows, so show
            fitment checker.
          */

          box.hidden =
            false;

          var status =
            $(
              '[data-fitment-status]',
              box
            );

          var vehicleText =
            $(
              '[data-fitment-vehicle]',
              box
            );

          var button =
            $(
              '[data-open-no-garage]',
              box
            );

          if (
            !status ||
            !vehicleText
          ) {
            return;
          }

          box.classList.remove(
            'is-fit',
            'is-not-fit',
            'is-unknown'
          );

          if (button) {

            button.style.display =
              '';
          }

          /* ===============================================
             NO ACTIVE VEHICLE
             =============================================== */

          if (!active) {

            status.textContent =
              'Check if this fits your vehicle';

            vehicleText.textContent =
              'Select or save a vehicle in My Garage.';

            if (button) {

              button.textContent =
                'Select vehicle';
            }

            box.classList.add(
              'is-unknown'
            );

            return;
          }

          vehicleText.textContent =
            vehicleName(active);

          if (button) {

            button.textContent =
              'Change vehicle';
          }

          /* ===============================================
             CONFIRMED FIT
             =============================================== */

          var fits =
            rows.some(
              function (row) {

                return rowMatchesVehicle(
                  row,
                  active
                );
              }
            );

          if (fits) {

            status.textContent =
              '✓ Confirmed fit';

            box.classList.add(
              'is-fit'
            );

            return;
          }

          /* ===============================================
             NEED ENGINE / TRIM
             =============================================== */

          if (
            productNeedsMoreDetails(
              rows,
              active
            )
          ) {

            status.textContent =
              'Add engine or trim to verify fitment';

            box.classList.add(
              'is-unknown'
            );

            return;
          }

          /* ===============================================
             NOT LISTED
             =============================================== */

          status.textContent =
            'Fitment not listed for your vehicle';

          box.classList.add(
            'is-not-fit'
          );
        }
      );
  }

  /* =========================================================
     COMPATIBILITY TABLE
     ========================================================= */

  function renderCompatibilityTables() {

    $$(
      '.no-fitment-chart[data-product-id]'
    )
      .forEach(
        function (chart) {

          var productID =
            chart.getAttribute(
              'data-product-id'
            );

          /*
            Universal products don't
            need YMM compatibility table.
          */

          if (
            isUniversalProduct(
              productID
            ) ||
            universalApplicationNote(
              productID
            )
          ) {

            chart.hidden =
              true;

            return;
          }

          var rows =
            rowsForProduct(
              productID
            );

          var body =
            $(
              'tbody',
              chart
            );

          if (!body) {
            return;
          }

          /*
            No YMM rows =
            don't show compatibility table.
          */

          if (
            !rows.length
          ) {

            chart.hidden =
              true;

            return;
          }

          chart.hidden =
            false;

          body.innerHTML =
            '';

          rows.forEach(
            function (row) {

              var tr =
                document.createElement(
                  'tr'
                );

              var yearText =
                Number(row.yearStart) ===
                Number(row.yearEnd)
                  ? String(
                      row.yearStart
                    )
                  : (
                      row.yearStart +
                      '–' +
                      row.yearEnd
                    );

              var values =
                [
                  yearText,

                  row.make ||
                    '—',

                  row.model ||
                    '—',

                  row.engine ||
                    'Any / Not specified',

                  row.submodel ||
                    'Any / Not specified'
                ];

              values.forEach(
                function (value) {

                  var td =
                    document.createElement(
                      'td'
                    );

                  td.textContent =
                    value;

                  tr.appendChild(
                    td
                  );
                }
              );

              body.appendChild(
                tr
              );
            }
          );
        }
      );
  }

  /* =========================================================
     MASTER UPDATE
     ========================================================= */

  function updateEverything() {

    if (
      window.NO_GARAGE_RENDER_LIST
    ) {

      window.NO_GARAGE_RENDER_LIST();

    } else {

      updateGarageButton();
    }

    renderFitmentBoxes();

    renderCompatibilityTables();
  }

  /* =========================================================
     CLICK EVENTS
     ========================================================= */

  document.addEventListener(
    'click',
    function (event) {

      if (
        !event.target ||
        typeof event.target.closest !==
          'function'
      ) {
        return;
      }

      var openButton =
        event.target.closest(
          '[data-open-no-garage]'
        );

      if (openButton) {

        event.preventDefault();

        openGarage();

        return;
      }

      var toggle =
        event.target.closest(
          '#noGarageToggle'
        );

      if (toggle) {

        event.preventDefault();

        openGarage();

        return;
      }

      var close =
        event.target.closest(
          '#noGarageClose'
        );

      if (close) {

        event.preventDefault();

        closeGarage();
      }
    }
  );

  /* =========================================================
     BACKDROP CLOSE
     ========================================================= */

  document.addEventListener(
    'click',
    function (event) {

      if (
        event.target &&
        event.target.id ===
          'noGarageBackdrop'
      ) {

        closeGarage();
      }
    }
  );

  /* =========================================================
     ESCAPE CLOSE
     ========================================================= */

  document.addEventListener(
    'keydown',
    function (event) {

      if (
        event.key ===
          'Escape'
      ) {

        closeGarage();
      }
    }
  );

  /* =========================================================
     SHOPIFY DYNAMIC PRODUCT REFRESH
     ========================================================= */

  function watchDynamicSections() {

    if (
      !window.MutationObserver ||
      !document.body
    ) {
      return;
    }

    var scheduled =
      false;

    var observer =
      new MutationObserver(
        function (mutations) {

          var relevant =
            false;

          mutations.forEach(
            function (mutation) {

              Array.prototype
                .forEach.call(
                  mutation.addedNodes,
                  function (node) {

                    if (
                      relevant ||
                      !node ||
                      node.nodeType !== 1
                    ) {
                      return;
                    }

                    if (
                      node.matches &&
                      node.matches(
                        '.no-fitment-box, .no-fitment-chart'
                      )
                    ) {

                      relevant =
                        true;

                      return;
                    }

                    if (
                      node.querySelector &&
                      node.querySelector(
                        '.no-fitment-box, .no-fitment-chart'
                      )
                    ) {

                      relevant =
                        true;
                    }
                  }
                );
            }
          );

          if (
            relevant &&
            !scheduled
          ) {

            scheduled =
              true;

            requestAnimationFrame(
              function () {

                scheduled =
                  false;

                renderFitmentBoxes();

                renderCompatibilityTables();
              }
            );
          }
        }
      );

    observer.observe(
      document.body,
      {
        childList:
          true,

        subtree:
          true
      }
    );
  }

  /* =========================================================
     BOOT
     ========================================================= */

  function boot() {

    /*
      Safety cleanup in case a browser
      returns to the page while the
      previous drawer state was locked.
    */

    unlockPageScroll();

    initGarage();

    updateEverything();

    watchDynamicSections();

    document.addEventListener(
      'shopify:section:load',
      function () {

        updateEverything();
      }
    );

    window.addEventListener(
      'pageshow',
      function () {

        unlockPageScroll();

        updateEverything();
      }
    );

    window.addEventListener(
      'storage',
      function (event) {

        if (
          event.key ===
            STORAGE_ACTIVE ||
          event.key ===
            STORAGE_VEHICLES
        ) {

          updateEverything();
        }
      }
    );

    console.log(
      'Nitrous Outlet Garage loaded:',
      DATA.length,
      'fitment rows'
    );
  }

  if (
    document.readyState ===
      'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      boot
    );

  } else {

    boot();
  }

})();